export const BOOKING_URL = "https://todetranca.app.br/nyjuliabraids";
export const WHATSAPP_URL = "https://wa.me/5519971465955?text=Ol%C3%A1%20Julia!%20Vi%20o%20site%20e%20tenho%20uma%20d%C3%BAvida%3A%20";
export const WHATSAPP_PHONE = "(19) 97146-5955";
export const ADDRESS_LINE1 = "Rua Antônio Carlos Ruberti, 72";
export const ADDRESS_LINE2 = "Parque Residencial Vila União, Campinas - SP";
export const INSTAGRAM_URL = "https://www.instagram.com/nyjuliabraids";
export const PINTEREST_URL = "https://pin.it/5GrHlaGwB";
export const TIKTOK_URL = "https://www.tiktok.com/@nyjuliabraids2";
export const MAPS_URL = "https://www.google.com/maps/search/?api=1&query=Rua+Ant%C3%B4nio+Carlos+Ruberti%2C72%2CParque+Residencial+Vila+Uni%C3%A3o%2CCampinas+SP";
export const MAPS_EMBED_URL = "https://maps.google.com/maps?q=nyjuliabraids+campinas+sp&output=embed";
